import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SmallSongCard from './SmallSongCard'; // or your existing card component

const SongsListPage = ({ songs }) => {
  return (
    <Container fluid style={{ padding: '20px' }}>
      <h2 className="fw-bold mb-4">Songs</h2>
      <div>
        {songs.map((track) => (
          <div key={track.id} style={{ marginBottom: '0.5rem' }}>
            <SmallSongCard track={track} />
          </div>
        ))}
      </div>
    </Container>
  );
};

export default SongsListPage;
